<template lang="">
	<div class="responsive-note">

    <div>
      <v-btn
        class="pa-5 my-11 b"
        height="50px"
        outlined
        @click="openModalCopy"
      >
        <img class="pr-3" src="../../../../static/images/add-circle-black.svg"/>Adicionar copy
      </v-btn>
    </div>

		<v-alert
      v-if="success"
      dismissible
      text
      type="success"
    >
      Sucess
    </v-alert>

    <CopyFilter	/>

		<v-card>
      <v-data-table
        :headers="headers"
        :items="items.data"
        :range="7"
        class="elevation-2 fs-16"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        hide-default-footer
        @page-count="pageCount = $event"
        >
        <template v-slot:item.copy_updated_at="{item}">
          {{format(item.copy_updated_at)}}
        </template>
        <template v-slot:item.copy_is_active="{item}">
          <!-- {{item}} -->
          <status-toggle
            :item="item"
            :item-status="item.copy_is_active"
            item-type="copy"
            :updateAction="updateCopy"
            :disableAction="disableCopy"
          />
        </template>
        <template v-slot:item.actions="{item}">
          <button class="b-4 buttonCopyEdit ma-2"
            @click="setCopy(item)"
          >
            <img src="../../../../static/images/edit.svg"/>
          </button>
        </template>
        <template v-slot:no-data>
          <span>Registro não encontrado</span>
        </template>
			</v-data-table>
		</v-card>
    
    <!-- Pagination -->
		<v-card>
			<div
				v-if="!loading"
				class="list-footer">
				<span></span>
				<v-pagination
          v-model="page"
          :length="pageCount"
          color="#F0F1F3"
          :total-visible="7"
        ></v-pagination>
				<div class="goToPage">
					<span class="goToPage--text">
						Ir para página
					</span>
					<label>
						<input
							v-model="goToPage"
							type="text"
						>
						<button
							@click="goToPageRequest"
							:disabled="disabledGoTo"
						>
							<div
								class="button-wrapper--text">
								<i class="iconStyle icon-arrow-right d-flex justify-center align-center"></i>
							</div>
						</button>
						<span
							:class="showGoToPageHelpText ? '--show-helptext' : '--hide-helptext'"
							class="goToPage--helptext"
						>
							A página deve estar entre 1 e {{pageCount}}
						</span>
					</label>
				</div>
			</div>
		</v-card>

    <div style="height: 5px"></div>

    <!-- Addinng new copy -->
    <v-navigation-drawer
      v-model="drawer"
      fixed
      overlay
      temporary
      right
      width="620"
      height="100vh"
      style="background: var(--grey-day-010)"
    >
      <CopyForm v-on:close="drawer = false"/>
    </v-navigation-drawer>

	</div>
</template>
<script>
// Component
import CopyFilter from '@/components/Contents/AutomaticsTriggers/CopyFilter.vue'
import StatusToggle from '@/components/StatusToggle.vue'
import CopyForm from '@/components/Contents/AutomaticsTriggers/CopyForm.vue'

import VueCookies from 'vue-cookies'

// Lib
import { mapActions, mapMutations, mapState } from 'vuex'

//mixins
import date from '../../../mixins/date'
import toaster from '@/mixins/toaster.js'

export default {
  mixins: [date, toaster],
	components: {
		CopyFilter,
		StatusToggle,
    CopyForm
  },
  data () {
		return {
			goToPage: 1,
      showGoToPageHelpText: false,
      disabledGoTo: false,
      drawer: false,
      copy_text: '',
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      success: false,
      status: false,
		}
  },
	async created () {
    this.setLoading(true)
    const token = VueCookies.get('jwt-login')
    try {
      this.setStatusFilter(null)
      this.setProductFilter('')
      this.setProductPageSize(100)
      await this.getProducts({token: token})
      await this.getCopies({token: token})
      this.setLoading(false)
    } catch (error) {
      this.toaster(
        'Erro na requisição',
        "warning",
        true
      );
    }
  },
  computed: {
    ...mapState('Copy', {
      items: 'items',
      loading: 'loading',
      size: 'size',
      pagination: 'pagination'
    }),
    ...mapState('Product', {
      itemsProducts: 'items',
    }),
    headers () {
      return [
        { value: '', text: '', height: "68px", class: 'headerTable grey lighten-2' },
        { value: 'copy_name', text: 'Copy', height: "68px", class: 'headerTable grey lighten-2' },
        { value: 'product.product_name', text: 'Produto', height: "68px", class: 'headerTable grey lighten-2' },
        { value: 'copy_updated_at', text: 'Atualizado em', sortable: true, height: "68px",class: 'headerTable grey lighten-2' },
        { value: 'copy_is_active', text: 'Status', height: "68px", class: 'headerTable grey lighten-2' },
        { value: 'actions', text: '', class:"grey lighten-2" }
      ]
    },
    itemStatus (item) {
      return item.copy_is_active
    },
  },
  methods: {
    ...mapActions('Product', [
      'getProducts',
    ]),
		...mapActions('Copy', [
      'getCopies',
      'updateCopy',
      'disableCopy'
    ]),
    ...mapMutations('Product', {
      setProductPageSize: 'SET_PAGE_SIZE'
    }),
		...mapMutations('Copy', {
      setCopyToEdit: 'SET_COPY_TO_EDIT',
      setLoading: 'SET_LOADING',
      setPage: 'SET_PAGE',
      setStatusFilter: 'SET_STATUS_FILTER',
      setProductFilter: 'SET_PRODUCT_FILTER',
      unsetCopyToEdit: 'UNSET_COPY_TO_EDIT'
    }),
		async goToPageRequest() {
      this.page = +this.goToPage
    },
		setCopy (itemRow) {
      this.openModalCopy()
      this.setCopyToEdit(itemRow)
    },
    openModalCopy () {
      this.drawer = true
      this.unsetCopyToEdit()
    }
  },
	watch: {
      'goToPage' () {
      if (this.goToPage < 1 || this.goToPage > this.pageCount) {
        this.showGoToPageHelpText = true
        this.disabledGoTo = true
      } else {
        this.showGoToPageHelpText = false
        this.disabledGoTo = false
      }
    },
    'itemStatus' () {
      setTimeout(() => {this.success = true}, 5000) 
    }
  }
}
</script>
<style lang="scss" scoped>
.headerTable, td {
	font-size: 16px !important;
  height: 64px !important;
}

.fs-16 {
	font-size: 16px !important;
}

.b {
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
  text-transform: capitalize;
}

.list-footer {
	background: var(--white);
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.75rem 2.625rem;
  margin: 80px 0 10px 0px !important;
	height: 64px;
}

.v-pagination__navigation, .v-pagination__item {
  border: none;
  box-shadow: none
}

.goToPage {
    &--text {
      font-size: 14px;
      font-family: var(--dm-sans-regular);
      color: var(--dark-grey);
      margin-right: 20px;
    }

    label {
      border: 2px solid var(--grey-day-030);
      background: var(--white);
      border-radius: 4px;
      box-sizing: border-box;
      max-width: 84px;
      width: 80px;
      padding: 10px;
      position: relative;

      input {
        width: 54px;
        font-size: 1rem;
        color: var(--grey);
        font-family: var(--dm-sans-regular);
      }

      button {
        position: absolute;
        border-radius: 50%;
        border: none;
        padding: 0;
        top: 11px;
        right: 8px;
        background: var(--grey);
        cursor: pointer;

        i {
          color: var(--white);
          font-size: 1.25rem;
        }
      }

      button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    &--helptext {
      font-family: var(--dm-sans-regular);
      position: absolute;
      font-size: 12px;
      width: 120px;
      text-align: center;
      top: -55px;
      left: -24px;
      background: var(--dark-red);
      padding: 8px;
      color: var(--light-grey);
      border-radius: 4px;
    }

    .--hide-helptext {
      display: none;
    }

    .--show-helptext {
      display: block;
    }
  }

	.iconStyle {
		width: 20px;
		height: 20px;
		background: transparent
	}


.inputCopy {
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
  width: 492px; 
  height: 48px;
  padding: 15px;
  background: transparent;
  font-family: var(--dm-sans-regular);
  color: var(--grey);
}
	// .button-wrapper--text {
	// 	height

  .responsive-note {
    width: 1224px
  }
  @media screen and (max-width: 1377px) {
    .responsive-note {
      width: 819px
    }
  }
    

.list-footer {
	background: var(--white);
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.75rem 2.625rem;
  margin: 80px 0 10px 0;
	height: 64px;
}

.buttonCopyEdit {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/AutomaticsTriggers/Copy.vue